var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "bz-container" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "bz-titlebox" }, [
        _c("div", { staticClass: "bz-worp" }, [
          _c("div", { staticClass: "bz-box" }, [
            _c("div", { staticClass: "bz-sskuang" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchVal,
                    expression: "searchVal"
                  }
                ],
                staticClass: "bz-sousuo",
                attrs: { type: "text", placeholder: "请输入标题搜索" },
                domProps: { value: _vm.searchVal },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.searchVal = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("button", { staticClass: "bz-btn" }, [_vm._v("搜索")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bz-right-conent" }, [
            _c(
              "ul",
              _vm._l(_vm.list, function(d, i) {
                return _c("li", { key: i }, [
                  _c(
                    "div",
                    {
                      staticClass: "over Text-title",
                      on: {
                        click: function($event) {
                          _vm.shows(d, i)
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "left bz-yuandian" }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "left bz-txttitle",
                        domProps: {
                          innerHTML: _vm._s(_vm.keyword(d.title, _vm.searchVal))
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "right bz-copy",
                        class: d.isshow ? "rotates" : "norotate",
                        attrs: { src: "/static/img/TriangleCopy.png", alt: "" }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "title",
                      refInFor: true,
                      staticClass: "Text-content",
                      class: d.isshow ? "dispays" : "hides"
                    },
                    [
                      _c("p", { ref: "text", refInFor: true }, [
                        _vm._v(_vm._s(d.centent))
                      ])
                    ]
                  )
                ])
              })
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bz-title" }, [
      _c("span", [_vm._v("常见问题")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("img", {
        staticClass: "bz-sousuoimg",
        attrs: { src: "/static/img/assets/sou.png", alt: "" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3fee8136", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fee8136","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/conenter/problem.vue
// module id = null
// module chunks = 